<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CFMB3F/tc-custom/9780253056955.jpg?1737196000884" alt="This image is the cover for the book Black Women in White, Blacks in the Diaspora"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Black Women in White, Blacks in the Diaspora
      </h1>
      <p class="bookDescription body article font2">
        <p>" . . . pioneering. . . . This history, as Hine vividly depicts it, sheds light on the development of African-American professionals and offers as well the opportunity to analyze the intersection of race and gender." —The Nation</p><p>" . . . well-researched and innovative . . . Highly recommended." —Library Journal</p><p>"The book is full of poignant and sympathetic portraits of black nurses in their dedication and idealism, in their pain and anger at the relentless contempt of white nurses and in their deep concern for their community's health needs. . . . Hine has brilliantly fulfilled an aim other historians have neglected . . . " —The Women's Review of Books</p><p>"This well-researched book adds breadth and depth to the existing literature on the educational and professional history of black nurses, including the development of black hospitals and training schools in the US. . . . Highly recommended." —Choice</p><p>" . . . an important book not only because it is a serious effort to analyze nursing history in the context of American racism but also because it offers a vantage point on the experiences of black women at work." —Medical Humanities Review</p><p>"Darlene Clark Hine has written a thoughtful analysis of the struggles of African Americans striving for professional status and recognition. . . . an illuminating study of the interaction of race and gender in the construction of a professional identity." —The Journal of American History</p><p>This pathbreaking study analyzes the impact of racism on the development of the nursing profession, particularly on black women in the profession, during the first half of this century.  Hine uncovers shameful episodes in nursing history and probes the nature and extent of racial conflict and cooperation in the profession.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darlene Clark Hine, John McCluskey, David Barry Gaspar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4dfc48ee